export function createFailedVertical(data) {
    return {
        verticalKey: data.verticalConfigId,
        errorType: data.errorType,
        queryDurationMillis: data.queryDurationMillis,
        details: data.details
    };
}
//# sourceMappingURL=createFailedVertical.js.map